import React, { memo, useMemo } from 'react';
import { TouchableOpacity } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { EntryDetails } from '@/api/entries/types/types';
import { CloseIcon } from '@/assets/icons/close';
import ShareIcon from '@/assets/icons/share-icon';
import { PickProgressDots } from '@/components/PickProgressDots';
import { Box, Row } from '@/components/lib/components';
import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

export const EntryHeaderActions = memo(({ entry }: { entry: EntryDetails }) => {
    const navigation = useNavigation();
    const picks = useMemo(() => entry?.picks ?? [], [entry?.picks]);
    const reuseShareLineupEnabled = useJurisdictionStore(
        state => state.jurisdictionSettings?.productConfig?.settings.enable_share_and_reuse_lineups
    );

    return (
        <Row px={'s16'} py={'s18'} justifyContent={'space-between'} alignItems={'center'}>
            <TouchableOpacity hitSlop={20} activeOpacity={0.8} onPress={() => navigation.goBack()}>
                <CloseIcon />
            </TouchableOpacity>
            <PickProgressDots picks={picks} light={false} />
            <Box width={24}>
                {reuseShareLineupEnabled ? (
                    <TouchableOpacity
                        onPress={() => {
                            BetrAnalytics.trackEvent(AnalyticsEvent.SHARE_ENTRY, {
                                screen: 'entry_details',
                            });
                            navigation.navigate('EntryShare', {
                                id: entry?.id,
                            });
                        }}
                    >
                        <ShareIcon />
                    </TouchableOpacity>
                ) : null}
            </Box>
        </Row>
    );
});
